import './jquery'

import 'admin-lte/plugins/jQueryUI/jquery-ui.min'
import 'admin-lte/plugins/fastclick/fastclick'
import 'admin-lte/plugins/slimScroll/jquery.slimscroll.min'
import 'admin-lte/dist/js/app.min'

import 'font-awesome/css/font-awesome.min.css'
import 'ionicons/dist/css/ionicons.min.css'
import 'admin-lte/bootstrap/css/bootstrap.min.css'
import 'admin-lte/dist/css/AdminLTE.min.css'
import 'admin-lte/dist/css/skins/_all-skins.min.css'
import 'admin-lte/plugins/iCheck/flat/blue.css'


import './custom.css'





// WEBPACK FOOTER //
// ./src/common/template/dependencies.js